import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFarmerByAadhar, fetchUserWallet, fetchUsertransactions, fetchPaidFarmerByTXId, createPaymentSession } from '../api/APIService';
import Toast from './Toast';
import Loader from './Loader';
import logo from '../img/logo.png'
import farmerIdImage from '../img/identity.png'
import indian_flag from '../img/indian_flag.png';
import bg_mitra_emblem_of_india from '../img/Emblem_of_India.png';
import FarmerCardPDF from '../pdf/AgriStackPDF';
import { pdf } from '@react-pdf/renderer';
import QRCode from 'qrcode';
import { useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import Checkout from './Checkout';


const AgriStackPage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [aadharNumber, setAadharNumber] = useState('');
    const [userWallet, setUserWallet] = useState({});
    const [transactions, setTransactions] = useState([]);
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
    const [errors, setErrors] = useState({});
    const [rechargeAmount, setRechargeAmount] = useState(0);
    const [utr, setUtr] = useState('');
    const [upiQRImage, setUPIqrImage] = useState();
    const [statusFilter, setStatusFilter] = useState('all');
    const [sortOrder, setSortOrder] = useState('desc');
    const [transactionId, setTransactionId] = useState('');

    const [showCheckout, setShowCheckout] = useState(false);
    const [paymentSession, setPaymentSession] = useState();

    useEffect(() => {
       // fetchWallet();
    }, []);

    const sampelCard = () => {
        const sapleResposne = {
            "userId": 35,
            "nameMr": "शेतकऱ्याचे नाव",
            "nameEn": "Farmers Name in english",
            "dob": "जन्म तारीख",
            "gender": "Male",
            "mhFarmerId": null,
            "centralId": "12341234123",
            "addressMr": "Address -Pincode",
            "addressEn": "Address -Pincode",
            "mobileNumber": "मोबाइल नंबर",
            "aadharNo": "MTIzNDEyMzQxMjM0",
            "createdBy": "navnathadsul99@gmail.com",
            "paymentId": 89,
            "totalArea": 5.5,
            "khataNumbers": {
                "शिवार1": [
                    "खाते क्रमांक"
                ],
                "शिवार2": [
                    "खाते क्रमांक"
                ]
            },
            "landDetails": {
                "शिवार1": [
                    "सर्वे नंबर"
                ],
                "शिवार2": [
                    "सर्वे नंबर"
                ]
            }
        }
        preparePdf({ data: sapleResposne });
    }

    const fetchTransaction = async () => {
        setLoading(true);
        try {
            //const transresponse = await fetchUsertransactions();
            //setTransactions(transresponse.data);
        } catch (error) {
            setToast({ show: true, message: error.response?.data || "Please try again!", type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const fetchWallet = async () => {
        setLoading(true);
        try {
            const response = await fetchUserWallet();
            setUserWallet(response.data);
            if (response?.data?.chargeAmount) {
                setRechargeAmount(response.data.chargeAmount * 2);
            }

            await fetchTransaction();
        } catch (error) {
            setToast({ show: true, message: error.response?.data || "Please try again!", type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const validate = () => {
        const aadhaarRegex = /^(?!0|1)(\d{12}|\d{4}\s\d{4}\s\d{4})$/;
        const newErrors = {};
        if (!aadharNumber.trim()) {
            newErrors.aadharNumber = "Please enter valid aadhar number.";
        } else if (!aadhaarRegex.test(aadharNumber)) {
            newErrors.aadharNumber = "Please enter valid aadhar number.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const downloadFarmerCard = async () => {
       // if (validate()) {
            setLoading(true);
            try {
              //  let cleanAadhar = aadharNumber.replace(/\s+/g, '');
                const response = await fetchFarmerByAadhar(aadharNumber);
                await preparePdf(response);
                setToast({ show: true, message: "Farmer card downloaded successfully!", type: 'success' });
            } catch (error) {
                setToast({ show: true, message: error.response?.data || "Please try again!", type: 'error' });
            } finally {
                setLoading(false);
            }
       // }
    };

    const downloadPaidFarmerCard = async (txtId) => {
        setLoading(true);
        try {
            const response = await fetchPaidFarmerByTXId(txtId);
            await preparePdf(response);
        } catch (error) {
            setToast({ show: true, message: error.response?.data ? error.response?.data : "Please try again!", color: 'danger' });
            setLoading(false);
        }
    }

    const preparePdf = async (response) => {
        try {
            const qrdata = await QRCode.toDataURL(`नाव-${response?.data?.nameMr} | ID-${response?.data?.centralId}`);

            // Create dummy image if photograph is not present
            const dummyImage = 'data:image/svg+xml;base64,' + btoa(`
                <svg width="60" height="80" xmlns="http://www.w3.org/2000/svg">
                    <rect width="60" height="80" fill="#f0f0f0" stroke="#ccc"/>
                    <text x="30" y="35" text-anchor="middle" font-size="10" fill="#666">No</text>
                    <text x="30" y="50" text-anchor="middle" font-size="10" fill="#666">Photo</text>
                </svg>
            `);

            const farmer = {
                ...response.data,
                photograph: response.data.photograph ?
                    "data:image/jpeg;base64," + response.data.photograph :
                    dummyImage
            };

            const fileName = `${farmer?.nameEn?.replaceAll(" ", "_")}-${Date.now()}.pdf`;
            const blob = await pdf(<FarmerCardPDF farmerIdImage={farmerIdImage} emblem_of_india={bg_mitra_emblem_of_india} indian_flag={indian_flag} farmer={farmer} logo={logo} qrImage={qrdata} />).toBlob();

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
            fetchWallet();

        } catch (error) {
            console.log(error)
            setLoading(false);
        }

    }


    const debouncedSetQrValue = useMemo(() => {
        return debounce((value) => {
            generateQR(value); // pass value
        }, 250);
    }, []);


    useEffect(() => {
        debouncedSetQrValue(rechargeAmount);
        return () => debouncedSetQrValue.cancel();
    }, [rechargeAmount]);


    const generateQR = async (amount) => {
        const qrdata = await QRCode.toDataURL(`upi://pay?pa=9adsul-hdfc@ybl&pn=Vakralabs Services&am=${amount}&cu=INR&tn=Recharge`);
        setUPIqrImage(qrdata);
    };



    const convertGMTToIST = (gmtDateString) => {
        const gmtDate = new Date(gmtDateString);

        // Use Intl.DateTimeFormat to get IST parts directly
        const formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });

        const parts = formatter.formatToParts(gmtDate);
        const get = (type) => parts.find(p => p.type === type)?.value;

        const day = get('day');
        const month = get('month');
        const year = get('year');
        const hour = get('hour');
        const minute = get('minute');
        const second = get('second');

        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    };

    const getRowColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'success':
            case 'completed':
                return '#d4edda'; // Light green
            case 'failure':
            case 'failed':
                return '#f8d7da'; // Light red
            case 'pending':
                return '#fff3cd'; // Light yellow
            default:
                return 'transparent';
        }
    };

    const filteredAndSortedTransactions = useMemo(() => {
        let filtered = transactions;

        console.log(statusFilter);
        // Filter by status
        if (statusFilter !== 'all') {
            filtered = transactions.filter(transaction =>
                transaction.status?.toLowerCase() === statusFilter.toLowerCase()
            );
        }

        // Sort by date
        return filtered.sort((a, b) => {
            const dateA = new Date(a.txDate);
            const dateB = new Date(b.txDate);
            return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
        });
    }, [transactions, statusFilter, sortOrder]);
    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">ID Card</h1>

            <div
                style={{
                    background: "#fff3cd",
                    border: "2px solid #dc3545",
                    padding: "15px",
                    borderRadius: "8px",
                }}
            >
                <h2 style={{ color: "#dc3545", marginTop: 0 }}>
                    📢 महत्त्वाची सूचना
                </h2>

                <p style={{ fontWeight: "bold", color: "#555" }}>
                    दिनांक: १९ जुलै २०२६
                </p>

                <p>
                    <strong>दि. १६ जुलै २०२६</strong> रोजी आमच्या वेबसाइटवर
                    <strong> सायबर सुरक्षा घटना (Cyber Security Incident)</strong> घडली.
                    या घटनेमुळे ऑनलाइन ID निर्मिती सेवा प्रभावित झाली. आम्ही सेवा
                    पूर्ववत सुरू करण्यासाठी सर्वतोपरी प्रयत्न केले, परंतु ती पूर्णपणे
                    पूर्ववत करणे शक्य झाले नाही.
                </p>

                <p>
                    त्यामुळे, विचारपूर्वक निर्णय घेऊन
                    <strong> या वेबसाइटवरील ऑनलाइन ID निर्मिती सेवा कायमस्वरूपी बंद</strong>
                    करण्याचा निर्णय घेतला आहे.
                </p>

                <p>
                    <strong>आपल्या खात्यातील शिल्लक रक्कम</strong> आपण ज्या माध्यमातून
                    (Original Payment Method) पेमेंट केले आहे, त्याच माध्यमातून
                    <strong> परत (Refund)</strong> करण्यात येईल.
                </p>

                <div
                    style={{
                        background: "#198754",
                        color: "#fff",
                        padding: "12px",
                        borderRadius: "6px",
                        fontWeight: "bold",
                        marginTop: "15px",
                    }}
                >
                    या निर्णयामुळे झालेल्या गैरसोयीबद्दल आम्ही दिलगीर आहोत.
                    गेल्या एक वर्षात आमच्यावर दाखवलेल्या विश्वास आणि सहकार्याबद्दल
                    मनःपूर्वक धन्यवाद.
                </div>

                <p style={{ fontWeight: "bold", color: "#198754", fontSize: "18px" }}>
                    🟢 अधिक माहितीसाठी कृपया WhatsApp वर संपर्क साधा:
                    <br />
                    📱 +91 9423886986
                </p>
            </div>

            <ol style={{ color: "red", textAlign: 'justify' }}>
                {/*  <li>Disclaimer - ओळखपत्रामध्ये वापरलेले भारताचे राष्ट्रीय चिन्ह (National Emblem of India) "राजमुद्रा", AgriSatck या महाराष्ट्र शासनाच्या प्रोजेक्ट चा लोगो आणि राष्टीय ध्वज हे फक्त कार्ड आकर्षक दिसावे या या एकाच उद्देशाने वापरलेले आहे.</li>
                <li>सदरील कार्ड हे कोणत्याही शासकीय / निमशासकीय कामामध्ये ओळखपत्र म्हणून वापरता येणार नाही. </li>
                <li>  या कार्ड मध्ये शेतकऱ्याची माहिती जसे की, नाव , जन्म तारीख , आधार नंबर , मोबाइल नंबर, जमिनीची शिवारानुसार माहिती (खाते क्रमांक , सर्वे नंबर ) आहे .</li>
                <li>हे कार्ड फक्त शेतकऱ्यांना त्यांचा फार्मर Id लक्ष्यात राहावा या हेतूने तयार केले आहेत. </li> */}
                {/*  <li>Sample Farmer card <button className='btn btn-teal' style={{ '--bs-btn-padding-y': '0px' }} onClick={() => sampelCard()}>Download करा.</button> </li> */}
            </ol>

{/*              <div className="row">
                <div className="col-md-5">
                    <div className="card mb-4">
                        <div className="card-body">
                            <button className="btn btn-teal w-100 mb-3" onClick={() => navigate("/contact")}>
                                📞 Contact Us
                            </button>

                            {userWallet && userWallet?.active ? (
                                <div className="alert alert-success">
                                    Available Balance: ₹{userWallet?.availableAmount}
                                </div>
                            ) : (
                                <div className="alert alert-warning">
                                    तुमचा अकाउंट Activate करण्यासाठी +91 9423 8 86 9 86 नंबर वर कॉल करा./ व्हाट्सअँप वर message करा.
                                </div>
                            )}
                        </div>
                    </div> 
                      <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Download Farmer Card</h5>
                            <div className="mb-3">
                                <label className="form-label">
                                    Aadhar Number <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={aadharNumber}
                                    onChange={(e) => setAadharNumber(e.target.value)}
                                    placeholder="Enter Aadhar Number"
                                />
                                {errors.aadharNumber && (
                                    <div className="text-danger mt-1">{errors.aadharNumber}</div>
                                )}
                            </div>

                            <button
                                className="btn btn-teal w-100"
                                onClick={downloadFarmerCard}
                                disabled={!(userWallet?.active && userWallet?.availableAmount >= userWallet.chargeAmount)}
                            >
                                Download Card / ₹ {userWallet.chargeAmount}
                            </button>
                        </div>
                    </div> 
                </div> 
            <div className="col-md-7">
                    <div className="card">
                        <Checkout userWallet={userWallet} onComplete={fetchWallet} /> 
                    </div>
                </div> 
        </div>*/}

            {
                transactions.length > 0 && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5>Transaction History</h5>
                                        <div className="d-flex gap-2">
                                            <select
                                                className="form-select form-select-sm"
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                style={{ width: 'auto' }}
                                            >
                                                <option value="all">All Status</option>
                                                <option value="success">Success</option>
                                                <option value="pending">Pending</option>
                                                <option value="failed">Failed</option>
                                            </select>
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc')}
                                            >
                                                {sortOrder === 'desc' ? '↓' : '↑'} Date
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-striped" style={{ fontSize: "small" }}>
                                            <thead>
                                                <tr><th>#</th>
                                                    <th>Description</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredAndSortedTransactions.map((transaction, index) => (
                                                    <tr key={index} style={{ backgroundColor: getRowColor(transaction.status) }}>
                                                        <td>{index + 1}</td>
                                                        <td>{transaction.description}</td>
                                                        <td>₹{transaction.txAmount}</td>
                                                        <td>
                                                            <span className={`badge ${transaction.status?.toLowerCase() === 'success' || transaction.status?.toLowerCase() === 'completed' ? 'bg-success' :
                                                                transaction.status?.toLowerCase() === 'failure' || transaction.status?.toLowerCase() === 'failed' ? 'bg-danger' :
                                                                    transaction.status?.toLowerCase() === 'pending' ? 'bg-warning' : 'bg-secondary'
                                                                }`}>
                                                                {transaction.status}
                                                            </span>
                                                        </td>
                                                        <td>{convertGMTToIST(transaction.txDate)}</td>
                                                        <td>{(transaction.txType == "DEBIT" && new Date(transaction.txDate) > new Date(Date.now() - 60 * 60 * 60 * 1000) &&
                                                            transaction.count < 4) && <button className="btn btn-teal" onClick={() => downloadPaidFarmerCard(transaction.walletTxId)} > PDF </button>}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            <Toast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <Loader show={loading} />
        </div >
    );
};

export default AgriStackPage;